<script>
import { h } from 'vue';
import { Form, FormItem, Button } from 'ant-design-vue';
import { DolIcon } from 'dolphin-framework-vue';
import DolFormItem from './dol-form-item.vue';

export default {
  name: 'dol-query-form',
  components: { DolFormItem },
  props: {
    fields: { type: Object, default: () => [] },
    showQueryFields: { type: Object, default: () => ({}) },
    form: { type: Object, default: () => ({})},
    layout: { type: String, default: 'inline' },
  },
  computed: {
    innerFields(){
      // 过滤出需要显示的字段
      const showFields = this.fields.filter(item => {
        if(item.queryFixed) return true;
        if(typeof item.queryFilter === 'undefined') return false;
        if(typeof this.showQueryFields[item.dataIndex] === 'boolean') return this.showQueryFields[item.dataIndex];
        return item.queryFilter;
      });

      // 处理特殊格式
      return showFields.map(item => {
        const field = { ...item };
        if(field.queryParams?.like){
          field.dataIndex = `${field.dataIndex}_like`;
        }
        return field;
      });
    },
  },
  data () {
    return {};
  },
  methods: {
    refresh(){
      this.$emit('refresh');
    }
  },
  render(){
    const formParams = {
      class: `dol-query-form`,
      layout: this.layout,
    };
    const formChildren = [];

    // 表单项
    this.innerFields.forEach(field => {
      const formItemParams = {
        field: field,
        form: this.form,
        type: 'queryForm',
        onPressEnter: () => this.refresh(),
      }
      formChildren.push(h(DolFormItem, formItemParams, () => undefined));
    });

    // 查询按钮
    const queryIcon = h(DolIcon, { type: 'SearchOutlined' });
    const queryButton = h(Button, { onClick: this.refresh }, () => [queryIcon]);
    const queryFormItem = h(FormItem, { class: 'query-button-item' }, () => [queryButton])
    formChildren.push(queryFormItem);

    return h(Form, formParams, () => formChildren);
  },
}
</script>

<style lang="scss">

</style>
